<div class="filtered-users-preview">
  <div
    class="user-navigation"
    [ngClass]="{
      'hidden-control': _users.length < 2,
      'disabled-control': currentlySelectedIndex === 0,
    }">
    <span class="fa fa-chevron-left" (click)="showPreviousUser()"></span>
  </div>
  <div class="currently-selected-user">
    <ng-container *ngIf="currentlySelectedUser">
      <app-selected-user
        [currentIndex]="currentlySelectedIndex"
        [totalNumberOfUsers]="_users.length"
        [user]="currentlySelectedUser"></app-selected-user>
    </ng-container>
  </div>
  <div
    class="user-navigation"
    [ngClass]="{
      'hidden-control': _users.length < 2,
      'disabled-control': currentlySelectedIndex === _users.length - 1,
    }">
    <span class="fa fa-chevron-right" (click)="showNextUser()"></span>
  </div>
</div>
